/**
 * Guided tour for the Drone Tours page (``DroneViewer``).
 *
 * Importing this module registers the tour as a side effect — import it
 * once anywhere in the bundle (we do it from ``DroneViewer``) and the
 * registration is permanent for the lifetime of the app.
 *
 * Targeting hooks live on ``DroneViewer.tsx``:
 *   - ``drone-types-tabs``   → the Radix TabsList for drone type filters
 *   - ``drone-video-item``   → each per-drone Card in the sidebar
 */
import { registerTour } from '@/features/tours';
import { clickPreferReact } from '@/features/tours/utils/dom';
import { FEATURE_FLAGS } from '@/features/featureFlags';

export const DRONES_TOUR_ID = 'drones.intro';

registerTour({
  id: DRONES_TOUR_ID,
  name: 'Drone Tours',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.DRONES_VIEWER.id,
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to Drone Tours',
      body:
        'View aerial 360\u00B0 drone tours of the property captured at ' +
        'different points in time.',
    },
    {
      id: 'drone-types',
      target: '[data-tour-id="drone-types-tabs"]',
      placement: 'bottom',
      spotlightPadding: 6,
      title: 'Switch between drone types',
      body:
        'Use these tabs to filter by the type of drone tour — overview, ' +
        'interior, etc.',
    },
    {
      id: 'video-item',
      target: '[data-tour-id="drone-video-item"]',
      placement: 'right',
      spotlightPadding: 6,
      title: 'Captured tours',
      body:
        'Each captured tour appears here with the dates it was filmed. ' +
        'Click a date to load that specific run.',
    },
    {
      id: 'play',
      target: '[data-tour-id="drone-video-item"]',
      placement: 'right',
      spotlightPadding: 6,
      title: 'Click to play',
      body:
        'Click any tour to play it in the viewer on the right. Hit ' +
        'Finish Tour and we\u2019ll start the first one for you.',
      // Click the first card on Finish. ``handleCardClick`` is a no-op
      // when the card is already selected (which it is on initial load),
      // so this is harmless either way and ensures the video begins
      // playing if the user navigated elsewhere mid-tour.
      onBeforeNext: () => clickPreferReact('[data-tour-id="drone-video-item"]'),
    },
  ],
});
